
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.944 1.102c-.65 0-1.275.258-1.735.718L7.952 9.078a.833.833 0 00-.22.388L6.97 12.52a.833.833 0 001.01 1.01l3.056-.763a.833.833 0 00.387-.22l7.257-7.256a2.454 2.454 0 00-1.735-4.19zm-.556 1.897A.787.787 0 1117.5 4.112l-.557.557-1.113-1.113.557-.557zm-1.736 1.735l1.114 1.113-5.359 5.359-1.484.371.37-1.484 5.36-5.359z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.722 2.722A2.361 2.361 0 002.36 5.083v10.695a2.361 2.361 0 002.36 2.36h10.695a2.361 2.361 0 002.361-2.36v-4.584a.833.833 0 00-1.666 0v4.584a.694.694 0 01-.695.694H4.722a.695.695 0 01-.694-.694V5.083a.694.694 0 01.694-.694h4.583a.833.833 0 100-1.667H4.722z","fill":"currentColor"}})])
          )
        }
      }
    